import clsx from "clsx"
import Image from "next/image"
import React from "react"

import QuoteMark from "../../../public/icons/quotemarks.svg"

interface TextProps {
  quote?: string
  quotee?: string
  quoteeTitle?: string
  quoteeImage?: {
    url: string
    title: string
    width: number
    height: number
  }
  quoteMarkColor?: string
}

const QuoteSingle: React.FC<TextProps> = ({
  quote,
  quotee,
  quoteeImage,
  quoteeTitle,
  quoteMarkColor = "fill-blue-50",
}) => (
  <div className="rounded-lg bg-steel-2.5 p-8">
    <QuoteMark alt="Quotemarks" className={quoteMarkColor} />
    <p className={clsx("my-8 body3")}>{quote}</p>
    <div className="flex items-center mt-6">
      <div className="w-12 h-12 mr-4 min-w-12">
        <Image
          sizes="(min-width: 144px) 144px, 100vw"
          width={quoteeImage.width}
          height={quoteeImage.height}
          src={quoteeImage.url}
          alt={quoteeImage.title}
          className="min-w-full rounded-xl"
        />
      </div>
      <div>
        <p className={clsx("uppercase caption3 whitespace-normal")}>{quotee}</p>
        {quoteeTitle && (
          <p className={clsx("uppercase caption3 whitespace-normal")}>
            {quoteeTitle}
          </p>
        )}
      </div>
    </div>
  </div>
)

export default QuoteSingle
